export default __webpack_public_path__ + "static/realWorldImg1-d1afb7661070fe0110246f30e917f499.webp";